import React from 'react'
import PropTypes from 'prop-types'
import {cva} from 'class-variance-authority'
import {cn} from '@/lib/utils'

const variant = {
    light: '',
    medium: 'theme-medium',
    dark: 'theme-dark'
}

export const ThemeBox = ({theme, attributes: {className, ...attributes}, ...props}) => {
    const variants = cva('bg-background text-foreground', {
        variants: {variant},
        defaultVariants: {
            variant: 'light'
        }
    })
    return <div className={cn(variants({variant: theme, className}))} {...attributes} {...props} />
}

ThemeBox.propTypes = {
    theme: PropTypes.string.isRequired,
    attributes: PropTypes.object
}

export const ThemeBoxDefinition = {
    component: ThemeBox,
    name: 'ThemeBox',
    noWrap: true,
    canHaveChildren: true,
    image: 'https://unpkg.com/css.gg@2.0.0/icons/svg/color-bucket.svg',
    inputs: [
        {
            name: 'theme',
            friendlyName: 'Theme',
            type: 'string',
            enum: Object.keys(variant)
        }
    ]
}

export default ThemeBox
